import {ActionType} from "../action_type";
import {Action} from "../actions/fetchHealthProtocolsAction";

interface healthProtocolsState {
  loading: boolean,
  error: string | null;
  data: string[];
}

const initialState = {
  loading: false,
  error: null,
  data: []
}

const fetchHealthProtocolsReducer = (state: healthProtocolsState = initialState, action: Action) => {
  switch (action.type) {
    case ActionType.FETCH_HEALTH_PROTOCOLS:
      return {loading: true, error: null, data: []};
    case ActionType.FETCH_HEALTH_PROTOCOLS_SUCCESS:
      return {loading: false, error: null, data: action.payload};
    case ActionType.FETCH_HEALTH_PROTOCOLS_ERROR :
      return {loading: false, error: action.payload, data: []};
    default:
      return state;
  }
}

export default fetchHealthProtocolsReducer;